module.exports = __webpack_public_path__ + "static/media/bsmart_big.2ab2beea.svg";